import { Link } from '@tanstack/react-router'
import { ArrowLeft } from 'lucide-react'

import { PageHeader } from '@/components/page-header'
import { BalanceSheetSection } from '@/features/reports/balance-sheet'

/** Assets against liabilities and equity, as an addressable screen of its own. */
export function ReportsBalanceSheetPage() {
  return (
    <>
      <Link
        to="/reports"
        className="inline-flex items-center gap-1.5 text-xs font-medium text-brand-text hover:text-brand-text-hover max-lg:min-h-11 max-lg:py-2"
      >
        <ArrowLeft className="size-3.5" aria-hidden />
        All reports
      </Link>

      <PageHeader
        title="Balance sheet"
        description="Assets against liabilities and equity, as at a business date — and whether the two sides agree."
      />

      <BalanceSheetSection />
    </>
  )
}
